import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Chips, Button } from 'gdpp-components/dist/cjs/components/atoms'

import './style.scss'

const selectedItemsGenerator = (blocks) => {
  const selectedItem = []
  blocks.forEach((block) => {
    block.elements.forEach((ele) => {
      if (ele.type === 'input') {
        if (ele.value) {
          selectedItem.push({ type: 'input', id: ele.key, label: `${ele.value}(${ele.label})`, value: ele.value })
        }
      }
      if (ele.type === 'check') {
        ele.options.forEach((option) => {
          if (option.checked) {
            selectedItem.push({ type: 'check', id: ele.key, label: option.label, extraClasses: option.extraClasses })
          }
        })
      }
      if (ele.type === 'select') {
        if (ele.value.length > 0) {
          ele.value.forEach((val) => {
            selectedItem.push({ type: 'select', id: ele.key, label: val, values: ele.value })
          })
        }
      }
    })
  })
  return selectedItem
}

const getRestValuesForSelect = (value, values) =>
  values &&
  values.filter((val) => {
    return val !== value
  })

const FilterSelected = ({ blocks, updateFilterData }) => {
  const intl = useIntl()
  const selectedItem = selectedItemsGenerator(blocks)
  return (
    <>
      {selectedItem.length > 0 && (
        <div className="fund-filter__selected text-left">
          {selectedItem.map((item, index) => {
            const typeMapping = { input: '', check: false, select: getRestValuesForSelect(item.label, item.values) }
            const cleanSelected = () => updateFilterData({ type: item.type, id: item.id, value: typeMapping[item.type], label: item.label })
            return (
              <Chips
                id={`fil-fund-filter__badge-${item.type}-${item.id}`}
                key={index}
                value={item.label}
                extraClasses={item.extraClasses}
                onClick={cleanSelected}
              />
            )
          })}
          <Button
            kind="textlink"
            size="small"
            iconSize="16"
            label={intl.formatMessage({ id: 'fundList.filter.clearAll' })}
            onClick={() => updateFilterData({ clearAll: true })}
          />
        </div>
      )}
    </>
  )
}

FilterSelected.propTypes = {
  blocks: PropTypes.array.isRequired,
  updateFilterData: PropTypes.func.isRequired
}

FilterSelected.defaultProps = {}

export default FilterSelected
